import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

const General = ({ data }) => {
  return (
    <DescriptionList stripEmpty={true} data={data} disableGutters={true}>
      <DescriptionItem
        label={'Original amount'}
        field={'initialAmount'}
        type={'amount'}
      />
      <DescriptionItem label={'CPI'} field={'cpi'} type={'amount'} />
      <DescriptionItem label={'Regs'} field={'regsCount'} type={'text'} />
    </DescriptionList>
  );
};

export default General;
